import { canDisplayDiscontinued as  baseCanDisplayDiscontinued } from "../../../../../store/products/reducers"
import { getHQCenterId, getLatinaVitoriaCenterId } from '../../../../../store/centers/reducers'

export const BaseProductLogic = props => {

    const product = props.result !== undefined ? props.result._source : props.product
    if (props.product && props.product.extra) product.extra = props.product.extra

    const getExtras = () => {
        const extras = {...product.extra}
        if (props.outlet) extras.outlet = product.outletQuality
        if (props.sectionFlag) extras.sectionFlag = props.sectionFlag
        if (props.list) extras.analyticsTag = props.list
        if (props.crossType) extras.crossType = props.crossType
        if (props.isComingFromCampaign) extras.comingFromCampaign = true
        return Object.keys(extras).length > 0 ? extras : null
    }

    const hasMinOrderWithStock = () => {
        const isMktool = product.isMktool || props.isMkToolsCenter
        return product.min !== null && product.min > 0 && product.stock > 0 && !isMktool
    }

    const getMin = () => {
        const isMktools = product.isMktool || props.isMkToolsCenter

        if (isMktools) {
            return product.min ? product.min : getStep()
        }

        return getStep()
    }
 
    const getStep = () => {
        if (props.isIkeaCenter && product.unit === 'M2') return 0.01

        const isContainer = (props.naturalStoneViewingPermissions.canViewBrazil && product.centerId == getLatinaVitoriaCenterId())
            || (props.naturalStoneViewingPermissions.canViewHQ && product.centerId == getHQCenterId())
        const shippingMethod = isContainer ? 'CONTAINER' : props.shippingMethod

        let step = 1

        if (product && (product.typeId === '01' || product.typeId === 'NEWS')) step = 1
        else if (product.minQty[shippingMethod]) step = product.minQty[shippingMethod]

        return step
    }

    const getLimit = () => {
        if (product.isProductDiscontinued) {
            if (product.isMktool && getLimitDiscontinued() > getLimitMktool()) {
                return getLimitMktool() < getMin() ? 0 : getLimitMktool()
            } else {
                return getLimitDiscontinued()
            }
        } else if (product.isMktool) {
            return getLimitMktool() < getMin() ? 0 : getLimitMktool()
        } else if (hasMinOrderWithStock()) {
            return getLimitMinOrderWithStock()
        } else if (props.outlet && product.outlet) {
            return getLimitDiscontinued()
        } else {
            return null
        }
    }

    const getLimitMktool = () => {
        let result = 0
        if (product.isMktool) {
            if (props.isMkToolsUsaCenter && (product.max || product.max === 0)) result = product.max
            else result = 1000
        }
        if (props.qtyProductCart[product.productId]) {
            result = result - parseInt(props.qtyProductCart[product.productId], 10)
        }
        return result
    }

    const getLimitDiscontinued = () => {
        let result = 0
        if (props.outlet) {
            if (product.stock_outlet) {
                result = parseInt(product.stock_outlet, 10)
            }
        } else {
            if (product.stock) {
                result = parseInt(product.stock, 10)
            }
        }
        if (props.qtyProductCart[product.productId]) {
            result = result - parseInt(props.qtyProductCart[product.productId], 10)
        }
        return result
    }

    const getLimitMinOrderWithStock = () => {
        let result = 0

        if (product.stock) {
            result = parseInt(product.stock, 10)
        }

        if (props.qtyProductCart[product.productId]) {
            result = result - parseInt(props.qtyProductCart[product.productId], 10)
        }

        return result;
    }

    const getType = () => {
        let type = null
        if (props.isIkeaCenter && product.brand === 'SERVICES') type = 'ikea_service'
        else if (props.isIkeaCenter) type = 'ikea'
        else if (props.isMkToolsCenter) type = 'mktools'
        return type
    }

    const getTypeProductForStyles = () => {
        if (props.isIkeaCenter && (product.brand === 'DEKTON' || product.brand === 'SILESTONE')) return 'SLAB'
        if(product.type == 'CLAD') return 'SLAB'
        else return product.type
    }

    const canDisplayDiscontinued = () => {
        return baseCanDisplayDiscontinued(
            product.webHeading,
            product.isProductDiscontinued,
            product.shouldShowDiscontinuedLabel
        )
    }

    const validateOutletPromotions = (allPromotions) => {
        if (allPromotions == undefined || allPromotions == null || Object.keys(allPromotions).length == 0) return []
        //remove other outlet types promos.
        allPromotions = Object.values(allPromotions).filter(promo => {
            if (promo.outlet && promo.outlet == true && promo.outlet_types != product.outletQuality) {
                return false
            }
            return true
        })

        return allPromotions
    }

    const goToProductCard = (_product) => {
        _product.extra = getExtras()
        if (props.indexOfList !== undefined) props.clickDetail(_product, props.list, props.indexOfList)
    }

    const isCosentinoGlobal = product.type === 'SLAB' && props.centerId != 1100 && product.centerId == 1100
    const isCosentinoBrazil = product.type === 'SLAB' && props.centerId != 7500 && product.centerId == 7500

    const canBuyBrand = () => {
        if (product.brand === 'ECLOS') {
            return (props.centerId == 1100 && (props.isPriorityCustomerForEclos || props.canViewEclosBrandInEurope)) || props.isAustralianCenter || props.isSelectedCenterAvailableToBuyEclosProducts
        }

        return true
    }

    return {
        getMin,
        getStep,
        getLimit,
        getLimitMktool,
        getLimitDiscontinued,
        getType,
        getTypeProductForStyles,
        canDisplayDiscontinued,
        validateOutletPromotions,
        getExtras,
        goToProductCard,
        product,
        isCosentinoGlobal,
        isCosentinoBrazil,
        canBuyBrand
    }
}

